import { render, staticRenderFns } from "./auditNotice.vue?vue&type=template&id=88cbd7c6&scoped=true"
import script from "./auditNotice.vue?vue&type=script&lang=js"
export * from "./auditNotice.vue?vue&type=script&lang=js"
import style0 from "./auditNotice.vue?vue&type=style&index=0&id=88cbd7c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cbd7c6",
  null
  
)

export default component.exports